import i18n from "i18next";   
import { initReactI18next } from "react-i18next"
import util from "./commons/services/util"
import auth from "./i18n.auth"
import ems from "./i18n.ems";
import inverterDetail from "./i18n.inverter";

const resources = {
  ko: {
    translation: {
      // Header
      key1: '프로젝트',
      key2: '마이페이지',
      key3: '로그아웃',
      // main
      key4: {
        line1: '머신러닝 분석과 발전량 예측 기술을 통해 실시간으로',
        line2: '시스템의 개별 모듈 발전량을 예측하고 발전상황을 감지하여',
        line3: '효율을 최적화합니다.',
      },
      // Footer
      key5: '개인정보처리방침',
      key6: '이용약관',
      // +DR
      key7: '+DR 활성화 기기 정보',
      key8: '전체 +DR 기기',
      key9: '실제 가동 +DR 기기',
      key9A: '전일 예측 +DR 가동 예상 기기',
      key10: '시간당 전력사용량 그래프 (kWh)',
      key11: '+DR 활성화 히스토리',
      key12: '발령일',
      key13: '활성화 기기 수',
      key14: 'DR 참여 기기 전체 리스트',
      key15: '+DR 활성화 기기',
      key16: '+DR 비활성화 기기',
      key17: '총',
      key18: '개',
      key19: '기기별',
      key20: '소비전력별',
      key21: '등록날짜별',
      key21A: '번호',
      key22: '기기',
      key23: '종류',
      key24: '전력기기 명',
      key25: 'MODEL 명',
      key26: '소비전력',
      key27: '보증 완료 기간',
      key28: '세부정보',
      key29: '수정',
      key30: '시간별 CLB (고객기준부하-kWh)',
      key30A: '등록된 DR 활성화 기기가 없습니다.',
      key30B: '알수없음',
      // 프로젝트
      key31: '프로젝트',
      key32: '프로젝트 등록',
      key33: '전체보기',
      key34: '총',
      key35: '개',
      key36: '최근순',
      key37: '과거순',
      key38: '주소',
      key39: '프로젝트명',
      key40: '입력',
      key41: '지도로 보기',
      key42: '번호',
      key43: '프로젝트명',
      key44: '주소',
      key45: '등록 날짜',
      key46: 'EMS',
      key47: '시설',
      key48: '수정',
      key49: '주  소',
      key50: '프로젝트',
      //프로젝트 등록
      key51: '프로젝트',
      key52: '프로젝트 등록',
      key53: '프로젝트명',
      key54: '프로젝트명을 입력하세요.',
      key55: '프로젝트 주소',
      key56: '프로젝트 주소를 검색하세요.',
      key57: '주소 검색',
      key58: '사업자 번호',
      key59: '유효성 검사',
      key60: '시설 목록',
      key61: '저장',
      // 마이 페이지
      key62: '마이페이지',
      key63: '시공사 정보',
      key64: '시공사 명',
      key65: '시공사 연락처',
      key66: '사업사등록증',
      key67: '사업자등록증 없음',
      key68: '사업자등록증',
      key69: '기본 정보',
      key70: '아이디',
      key71: '현재 비밀번호',
      key72: '변경할 비밀번호',
      key73: '변경할 비밀번호 확인',
      key74: '이메일 주소',
      key76: '변경',
      // 프로젝트 header
      key77: '탄소 감축량',
      // EMS
      key78: '전력 계통 상황',
      key79: '시스템 정보',
      key80: '태양광',
      key81: '전력 기기',
      key82: '배터리',
      key83: 'PV 사용전력',
      key84: 'ESS 사용전력',
      key85: '공급',
      key86: 'Charging',
      key87: 'Time',
      key88: '전압',
      key89: '전류',
      key90: 'Discharging',
      key91: '운용률',
      key92: '시간/날씨',
      key93: '날짜',
      key94: '시간',
      key95: '배터리 사양',
      key96: '용량',
      key97: '개수',
      key98: '태양광 사양',
      key99: '설비용량',
      key100: '개수',
      key101: '전력기기 사양',
      key102: '소비전력',
      key103: '개수',
      key104: '태양광',
      key105: '생산 전력',
      key106: '운용률',
      key107: '일간 발전량',
      key108: '전력 기기',
      key109: '수요 전력',
      key110: '일간 소비량',
      key111: '누적 소비량',
      key112: '배터리',
      key113: '운용률',
      key114: '일간 충전량',
      key115: '일간 발전량',
      key116: '일간 충전시간',
      key117: '일간 방전시간',
      key118: '누적 충전량',
      key119: '누적 충전시간',
      key120: '누적 발전량',
      key121: '누적 방전시간',
      key122: '에너지 상태 모니터링',
      key123: '현재',
      key124: '배터리 충전',
      key125: '배터리 방전',
      key126: '실제 수요',
      key127: '태양광 실제 발전량',
      // 시설
      key128: '시설',
      key129: '발전소',
      key130: '히트펌프',
      key131: '배터리',
      // 시설 - 발전소
      key132: '전체보기',
      key133: '총',
      key134: '개',
      key135: '등록날짜별',
      key136: '번호',
      key137: '발전소명',
      key138: '보증 완료 기간',
      key139: '세부정보',
      key140: '수정',
      // 시설 - 발전소 - 세부정보
      key141: '시설',
      key142: '발전소 세부정보',
      key143: '개별 모듈 전원 제어',
      key144: '인버터 데이터',
      key145: '설비 정보',
      key146: '설비용량',
      key147: '누적발전량',
      key148: '시공사 정보',
      key149: '시공사명',
      key150: '시공사 연락처',
      key151: '발전정보',
      key152: '금일 발전량',
      key153: '이전월 발전량',
      key154: '당월 발전량',
      key155: '금년 발전량',
      key156: '누적 발전량',
      key157: '금일 발전시간',
      key158: '이전월 발전시간',
      key159: '당월 발전시간',
      key160: '금년 발전시간',
      key161: '누적 발전시간',
      key162: '금일 발전수익',
      key163: '원',
      key164: '이전월 발전수익',
      key165: '당월 발전수익',
      key166: '금년 발전수익',
      key167: '누적 발전수익',
      key168: '현재시각',
      key169: '초',
      key170: '시간별 발전량 그래프(단위, kWh)',
      key171: '발전량',
      key172: '해당 그래프는 오늘 하루 시간때별로 발전된 발전량 정보를 제공합니다.',
      key173: '년',
      key174: '월',
      key175: '일',
      key176: '시',
      key177: '일자별 발전량 그래프(단위, kWh)',
      key178: '발전량',
      key179: '해당 그래프는 한달동안 일별로 발전된 시간당 발전량 정보를 제공합니다.',
      key180: '파일 다운로드',
      key181: '단선결선도 파일',
      key182: '도면 파일',
      key183: '모듈 인버터 시리얼번호 엑셀파일',
      key184: '기본 정보',
      key185: '운전 개시일',
      key186: '사업주 명',
      key187: '태양광 정보',
      key188: '태양광 모듈',
      key189: '구조물',
      key190: '전기공사',
      // 시설 - 발전소 - 발전소 상세정보 - 개별 모듈 전원 제어
      key191: '설비 정보',
      key192: '설비용량',
      key193: '누적발전량',
      key194: '시공사 정보',
      key195: '시공사명',
      key196: '시공사 연락처',
      key197: '상위',
      key198: '하위',
      key199: '작동안함',
      key200: '모듈 번호',
      key201: '발전 효율',
      key202: '입력',
      key203: '출력',
      key204: '전류',
      key205: '전압',
      key206: '전력',
      key207: '태양광 모듈 배치현황',
      key208: '전기회로적 레이아웃',
      key209: '인버터별 실시간 출력',
      key210: '이슈정보',
      key211: '이슈목록',
      key212: '원인',
      key213: '내용 입력',
      key214: '해결',
      key215: '저장 후 이슈종료',
      key216: '기본 정보',
      key217: '운전 개시일',
      key218: '사업주 명',
      key219: '태양광 정보',
      key220: '태양광 모듈',
      key221: '구조물',
      key222: '전기공사',
      // 시설 - 전력기기
      key223: '전체보기',
      key224: '총',
      key225: '개',
      key226: '기기별',
      key227: '소비전력별',
      key228: '등록날짜별',
      key229: '번호',
      key230: '기기',
      key231: '종류',
      key232: '전력기기명',
      key233: 'MODEL 명',
      key234: '소비 전력',
      key235: '보증 완료 기간',
      key236: '세부정보',
      key237: '수정',
      // 시설 - 전력기기 - 세부정보
      key238: '히트펌프 세부정보',
      key239: '설치위치',
      key240: '히트펌프 사용 정보',
      key241: '누적 소비전력',
      key242: '금일 소비전력',
      key243: '전체 기기 상태',
      key244: '통신 상태',
      key245: '정상',
      key246: '고장',
      key247: '통신오류',
      key248: '점검중',
      key249: '+DR',
      key250: '+DR 미발동',
      key251: '+DR 발동',
      key252: '보일러',
      key253: '전체 전원 관리',
      key254: '축열조 온도',
      key255: '현재 온도',
      key256: '목표 온도',
      key257: '보일러 실내 온도',
      key258: '(대표)',
      key259: '현재 온도',
      key260: '목표 온도',
      key261: '보일러 발전 정보',
      key262: '누적 소비전력',
      key263: '누적 난방 열량',
      key264: '기기 상태',
      key265: '현재 소비전력',
      key266: '금일 소비전력',
      key267: '운전모드',
      // 시설 - 전력기기 - 전력기기 추가 / 수정
      key268: '전력기기 수정',
      key269: '전력기기 종류',
      key270: '보일러',
      key271: '전력기기명',
      key272: 'MODEL 명',
      key273: '소비전력(kW)',
      key274: 'SITE 번호',
      key275: '기기번호',
      key276: '기기번호',
      key277: 'RTU 번호',
      key278: 'DR자원 식별자',
      key279: '운전 개시일',
      key280: '날짜를 선택하세요',
      key281: '서비스 보증 기간',
      key282: '날짜를 선택하세요',
      key283: '제어 항목',
      key284: '전원',
      key285: '온도',
      key286: '긴급차단',
      key287: '작동 모드',
      key288: '사전 예약',
      key289: '+DR (수요반응)',
      key290: '연결기기 선택',
      key291: '연결가능한 전력기기가 없습니다.',
      key292: '전력기기를 선택하세요.',
      key293: 'SITE 번호, RTU 번호가 일치하는 전력기기 선택 가능',
      key294: '삭제',
      key295: '전력기기 리스트',
      key296: '저장',
      key297: '수정',
      // 시설 - 배터리
      key298: '전체보기',
      key299: '총',
      key300: '개',
      key301: '용량별',
      key302: '등록날짜별',
      key303: '번호',
      key304: '배터리명',
      key305: '배터리 용량',
      key306: '보증 완료 기간',
      key307: '세부정보',
      key308: '수정',
      // 시설 - 배터리 - 배터리 세부정보
      key309: '배터리 세부정보',
      key310: '그래프 데이터',
      key311: '프로젝트명',
      key312: '설치위치',
      key313: '설비용량',
      key314: '배터리 정보',
      key315: 'SYSTEM MODE',
      key316: 'MANUAL',
      key317: 'SYSTEM',
      key318: '충/방전 모드',
      key319: '충전',
      key320: '방전',
      key321: '통신상태',
      key322: '정상',
      key323: '에러',
      key324: '충/방전모드 FLOW (0.0~20.00 LPM)',
      key325: 'S-1-1 Salt NaCl 충전',
      key326: 'B-1-1 Base NaOH 충전',
      key327: 'A-1-1 Acid HCl 충전',
      key328: 'E-1 Electrolyte Na2SO4 충전',
      key329: 'S-2-1 Salt NaCl 충전',
      key330: 'B-2-1 Base NaOH 충전',
      key331: 'A-2-1 Acid HCl 충전',
      key332: 'S-1-2 Salt NaCl 방전',
      key333: 'B-1-2 Base NaOH 방전',
      key334: 'A-1-2 Acid HCl 방전',
      key335: 'E-1 Electrolyte Na2SO4 방전',
      key336: 'S-2-2 Salt NaCl 방전',
      key337: 'B-2-2 Base NaOH 방전',
      key338: 'A-2-2 Acid HCl 방전',
      key339: '축/방전모드 PRESSURE (0.0~30.0 bar)',
      key340: 'S-1-1 Salt NaCl 축전',
      key341: 'B-1-1 Base NaOH 축전',
      key342: 'A-1-1 Acid HCl 축전',
      key343: 'E-1 Electrolyte Na2SO4 축전',
      key344: 'S-2-1 Salt NaCl 축전',
      key345: 'B-2-1 Base NaOH 축전',
      key346: 'A-2-1 Acid HCl 축전',
      key347: 'S-1-2 Salt NaCl 방전',
      key348: 'B-1-2 Base NaOH 방전',
      key349: 'A-1-2 Acid HCl 방전',
      key350: 'E-1 Electrolyte Na2SO4 방전',
      key351: 'S-2-2 Salt NaCl 방전',
      key352: 'B-2-2 Base NaOH 방전',
      key353: 'A-2-2 Acid HCl 방전',
      key354: 'PANEL 순간전력',
      key355: 'PANEL 누적 전력량',
      key356: 'ED1 충전모드 전압',
      key357: 'ED1 충전모드 전류',
      key357A: 'ED1 충전모드 전력량',
      key357B: 'ED1 충전모드 누적 전력량',
      key358: 'ED2 방전모드 전압',
      key359: 'ED2 방전모드 전류',
      key360: 'ED2 방전모드 전력량',
      key360A: 'ED2 방전모드 누적 전력량',
      // 시설 - 배터리 등록 / 수정
      key361: '배터리 등록',
      key362: '배터리 수정',
      key363: '배터리명',
      key364: 'MODEL 명',
      key365: '배터리 용량 (kWh)',
      key366: 'SITE 번호',
      key367: 'RTU 번호',
      key368: '기기 번호',
      key369: '운전 개시일',
      key370: '날짜를 선택하세요',
      key371: '서비스 보증 기간',
      key372: '날짜를 선택하세요',
      key373: '제어 항목',
      key374: '전원',
      key375: '온도',
      key376: '긴급차단',
      key377: '작동 모드',
      key378: '사전 예약',
      key379: '삭제',
      key380: '배터리 리스트',
      key381: '저장',
      // 인버터 데이터 그래프/리스트
      key382: "인버터 데이터 그래프/리스트",
      key383: "시간별 발전량(통계)",
      key384: "전체보기",
      key385: "총",
      key386: "개",
      key387: "기간설정",
      key388: "선택",
      key389: "DC, R/S/T 전압",
      key390: "DC, R/S/T 전류",
      key391: "전류(A)",
      key392: "DC, 현재 출력",
      key393: "출력(W)",
      key394: "리스트보기",
      // 시간별 발전량(통계) 목록
      key395: '시간별 발전량(통계) 목록',
      key396: '전체보기',
      key397: '총',
      key398: '개',
      key399: '기간설정',
      key400: '추가',
      key401: '번호',
      key402: '시리얼번호',
      key403: '날짜',
      key404: '시각',
      key405: '발전량(kWh)',
      key406: '편집',
      key407: '저장',
      key408: '조회된 결과가 없습니다.',
      // 시설 - 발전소 - 등록 / 수정
      key409: '발전소 등록',
      key410: '발전소 수정',
      key411: '발전소명',
      key412: '발전소명을 입력하세요',
      key413: '설비 용량',
      key414: '설치 장수', // 아마 "설치 장소"로 수정 필요
      key415: '장',
      key416: '도면 배치도',
      key417: '선택된 파일이 없음',
      key418: '파일선택',
      key419: '단선 연결도',
      key420: '모듈 인버터',
      key420A: '시리얼번호',
      key421: '양식 파일 다운로드',
      key422: '운전 개시일',
      key423: '날짜를 선택하세요.',
      key424: '서비스 보증 기간',
      key425: 'SMP + REC',
      key425A: '가격',
      key426: '1kW당',
      key427: '원',
      key428: '옵티마이저',
      key429: '사용여부',
      key430: '모듈 배치와 장비 및 통신정보를 등록해주세요.',
      key431: '모듈 시리얼 넘버 매치',
      key432: '장비 및 통신 정보',
      key434: '삭제',
      key435: '발전소 리스트',
      key436: '저장',
      // 시설 - 발전소 등록 / 수정 - 모듈 시리얼 넘버 매치
      key437: '전체 발전소 리스트',
      key438: '대기 발전소 등록',
      key439: '시리얼 넘버 불러오기',
      key440: '모듈 그리기 추가',
      key441: '행 개수',
      key442: '열 개수',
      key443: '배치 선택',
      key444: '세로배치',
      key445: '가로배치',
      key446: '방위각',
      key447: '취소',
      key448: '완료',
      key449: '모듈 삭제',
      key450: '모듈 추가',
      key451: '결선',
      key452: '시리얼 넘버 찾기',
      key453: '선택완료',
      key454: '저장',
      // 시설 - 발전소 등록 / 수정 - 장비 및 통신 정보
      key455: '전체 발전소 리스트',
      key456: '장비 및 통신정보 등록',
      key457: '장비리스트',
      key458: '자재 정보(인버터)',
      key459: '인버터번호',
      key460: '인버터명',
      key461: '인버터 제조사',
      key462: '인버터 용량',
      key463: '모듈명',
      key464: '모듈 제조사',
      key465: '모듈출력',
      key466: '모듈장수',
      key467: 'RTU번호',
      key468: 'RTU번호는 해당 인버터와 연결된 모든 모듈(옵티마이저)의 RTU번호로 상속시킴(Default)',
      key469: '확인',
      key470: '자재 정보(모듈)',
      key471: '지그비 번호',
      key472: '옵티몬 번호',
      key473: 'RTU번호',
      key474: '확인',

      // 파일 삭제 버튼
      key475: '파일 삭제',

      // 시설 - 발전소 - 발전소 상세정보 - 개별 모듈 전원 제어 - 내부
      key476: '패널온도',
      key477: '입력',
      key478: '출력',
      key479: '전류',
      key480: '전압',
      key481: '전력',
      key482: '인버터별 실시간 출력',
      key482A: '(전체보기)',
      key483: 'DC 전압',
      key484: 'DC 전류',
      key485: 'R상 전압',
      key486: 'R상 전류',
      key487: 'S상 전압',
      key488: 'S상 전류',
      key489: 'T상 전압',
      key490: 'T상 전류',

      // 배터리 데이터 그래프
      key491: '배터리 데이터 그래프',
      key492: '전체보기',
      key493: '총',
      key494: '개',
      key495: '충/방전모드 PRESSURE',

      // 모달 / 알럿
      key496: '배터리 정보 불러오기를 실패하였습니다.',
      key497: '전체 기기 점검중으로 설정하시겠습니까?',
      key498: '아니오',
      key499: '예',
      key500: '작업이 취소되었습니다.',
      key501: '해당기기의 온도 데이터가 없습니다.',
      key502: '해당기기 목표 온도는 최소 ',
      key503: '°C 입니다.',
      key504: '이 입력란을 작성하세요.',
      key505: '유효성 검사를 먼저 수행해주세요.',
      key506: '올바르지 않은 사업자번호입니다.',
      key507: '알림',
      key508: '수정하시겠습니까?',
      key509: '등록된 프로젝트가 존재하지 않습니다.',

      // 프로젝트 등록/수정 추가분
      key510: "올바르지 않은 사업자번호입니다.",
      key511: "올바른 사업자입니다.",
      key512: "저장하시겠습니까?",
      key513: "알림",
      key514: "프로젝트명을 입력해주세요.",
      key515: "프로젝트 주소를 입력해주세요.",
      key516: "사업자 번호를 입력해주세요.",
      key517: "프로젝트명은 36자 이하여야 합니다.",
      key518: "유효성 검사를 먼저 수행해주세요.",
      key519: "주소 검색을 이용해서 발전소 주소를 입력해주세요.",

      // 마이페이지 추가분
      key520: "비밀번호가 맞지 않아 변경이 불가합니다.",
      key521: "비밀번호가 일치하지 않습니다.",
      key522: "현재 비밀번호가 올바르지 않습니다.",

      // EMS 추가분
      key523: "배터리 정보 불러오기 실패",
      key524: "전력기기 정보 불러오기 실패",
      key525: "캐리어 데이터 불러오기 실패",
      key526: "수요",
      key527: "개",
      key528: "일간 방전량",

      // 시설 추가분
      key529: "등록된 시설이 존재하지 않습니다.",
      key530: "등록된 전력기기가 존재하지 않습니다.",
      key531: "알수없음",
      key532: "등록된 배터리가 존재하지 않습니다.",

      // 시설 - 발전소 상세 추가분 
      key533: "누적 발전량 그래프(단위, kWh)",
      key534: "월간",
      key535: "분기",
      key536: "연간",
      key537: "장",
      key538: "대",
      key539: "용용아연 철",
      key540: "글자",

      // 시설 - 발전소 상세정보 추가분
      key541: "발전소 상세정보",

      // 시설 - 발전소 상세정보 - 개별 모듈 전원 제어 추가분
      key542: "확대",
      key543: "초기화",
      key544: "축소",
      key545: "전원을 끄시겠습니까?",
      key546: "전원을 끄는데 성공했습니다.",
      key547: "전원을 켜시겠습니까?",
      key548: "전원을 켜는데 성공했습니다.",
      key549: "번 회로 전원 관리",
      key550: "DC 출력",
      key551: "R상 출력",
      key552: "S상 출력",
      key553: "T상 출력",

      // 시간별 발전량 (통계) 목록
      key554: "새로 추가할 정보를 입력하고 저장하세요.",
      key555: "날짜를 올바르게 입력하세요.",
      key556: "발전량을 입력하세요.",
      key557: "추가 하시겠습니까?",
      key558: "정상적으로 추가되었습니다.",
      key559: "이미 존재하는 데이터 입니다.",
      key560: "수정 하시겠습니까?",
      key561: "수정 되었습니다.",
      key562: "삭제 하시겠습니까?",
      key563: "삭제 되었습니다.",
      key564: "인버터",
      key565: "전체",
      key566: "시 (시간)",
      key567: "상세정보",
      key568: "시간",
      key569: "출력",
      key570: "누적발전량(kWh)",
      key571: "주파수",
      key572: "상태코드",

      // 발전소 추가 추가분 
      key573: "취소되었습니다.",
      key574: "발전소명을 입력해주세요.",
      key575: "설비용량을 입력해주세요.",
      key576: "설치장수를 입력해주세요.",
      key577: "SMP + REC 가격을 입력해주세요.",
      key578: "운전개시일을 입력해주세요.",
      key579: "서비스보증 기간을 입력해주세요.",
      key580: "모듈 인버터 시리얼 넘버를 첨부해주세요.",
      key581: "임시저장 후 모듈배치 화면으로 이동하세요.",
      key582: "발전소 삭제에 실패했습니다.",

      // date picker 추가분
      key583: "오늘",
      key584: "어제",
      key585: "1주일전",
      key586: "5년후",
      key587: "10년후",
      key588: "15년후",

      // 시설 발전소 등록 / 수정 - 모듈 시리얼 넘버 매치
      key589: "시리얼 넘버 찾기",
      // 장비 및 통신정보
      key590: "인버터",
      key591: "모듈",
      key592: "자재 정보",

      // 전력기기 수정 등록
      key593: "취소되었습니다.",
      key594: "전력기기 종류를 선택하세요.",
      key595: "전력기기명을 입력하세요.",
      key596: "Model 명을 입력하세요.",
      key597: "소비전력을 입력하세요.",
      key598: "Site 번호를 입력하세요.",
      key599: "기기 번호를 입력하세요.",
      key600: "RTU 번호를 입력하세요ㅣ.",
      key601: "운전 게시일을 입력하세요.",
      key602: "서비스 보증 기간을 입력하세요.",
      key603: "+DR(수요반응) 체크시 DR자원 식별자는 필수입니다. DR자원 식별자를 입력하세요.",
      key604: "전력기기 등록",
      key605: "기기 타입 추가 필요",
      key606: "전력기기명을 입력하세요.",

      // 전력기기 상세정보
      key607: "보일러 목표 온도 설정에 실패하였습니다.",
      key608: "끄시겠습니까?",
      key609: "켜시겠습니까?",
      key610: "예",
      key611: "아니오",
      key612: "성공적으로 수행되었습니다.",
      key613: "작업이 취소되었습니다.",
      key614: "개별 전원 관리에 실패했습니다.",
      key615: "전체 전원",
      key616: "전체 전원 관리에 실패했습니다.",
      key617: "해당기기의 온도 데이터가 없습니다.",
      key618: "해당기기는 온도조절이 불가능합니다.",
      key619: "해당기기 목표 온도는",
      key620: "최소",
      key621: "최대",
      key622: "°C 입니다.",
      key623: "전체 기기 점검중을 해제하시겠습니까?",
      key624: "전체 기기 점검중으로 설정하시겠습니까?",
      key625: "(하위)",
      key626: "시간별 소비전력 그래프(단위,kWh)",
      key627: "소비전력",
      key628: "일자별 소비전력 그래프(단위, kWh)",
      key629: "누적 소비전력 그래프(단위,kWh)",
      key630: "월간",
      key631: "분기",
      key632: "연간",

      // 배터리 추가 수정
      key633: "배터리명을 입력하세요.",
      key634: "Model 명을 입력하세요.",
      key635: "배터리 용량을 입력하세요.",
      key636: "Site 번호를 입력하세요.",
      key637: "Rtu 번호를 입력하세요.",
      key638: "기기 번호를 입력하세요.",
      key639: "운전 개시일을 입력하세요.",
      key640: "서비스 보증 기간을 입력하세요.",
      key641: "취소되었습니다.",

      // 배터리 상세
      key642: "배터리 정보를 불러오기를 실패하였습니다.",
      key643: "S-1 Salt NaCl",
      key644: "B-1 Base NaOH",
      key645: "A-1 Acid HCl",
      key646: "E-1 Electrolyte Na2SO4",
      key647: "S-2 Salt NaCl",
      key648: "B-2 Base NaOH",
      key649: "A-2 Acid HCl",
      key650: "Drain",
      key651: "S-1 Salt NaCl",
      key652: "B-1 Base NaOH",
      key653: "A-1 Acid HCl",
      key654: "E-1 Electrolyte Na2SO4",
      key655: "S-2 Salt NaCl",
      key656: "B-2 Base NaOH",
      key657: "A-2 Acid HCl",
      key658: "TANK PH (0.0~14.0PH)",
      key659: "TANK CONDUCTIVITY (0.0~500.0 ms)",
      key660: "충/방전모드 FLOW",
      ...auth.ko,
      ...ems.ko,
      ...inverterDetail.ko
    }
  },
  en: {
    translation: {
      // Header
      key1: 'Project',
      key2: 'My Page',
      key3: 'Logout',
      // main
      key4: {
        line1: 'Through machine learning analysis and power generation prediction technology,',
        line2: 'the system predicts the power generation of each module in real time',
        line3: 'detects generation status, and optimises efficiency.',
      },
      // Footer
      key5: 'Privacy Policy',
      key6: 'Terms of Use',
      // +DR
      key7: '+DR Activated Device Information',
      key8: 'Total +DR Devices',
      key9: 'Active +DR Devices',
      key9A: 'Predicted +DR Active Devices',
      key10: 'Hourly Power Usage Graph (kWh)',
      key11: '+DR Activation History',
      key12: 'Issued Date',
      key13: 'Number of Activated Devices',
      key14: 'Full List of DR Participating Devices',
      key15: '+DR Activated Devices',
      key16: '+DR Deactivated Devices',
      key17: 'Total',
      key18: 'Units',
      key19: 'By Device',
      key20: 'By Power Consumption',
      key21: 'By Registration Date',
      key21A: 'No.',
      key22: 'Device',
      key23: 'Type',
      key24: 'Power Device Name',
      key25: 'MODEL Name',
      key26: 'Power Consumption',
      key27: 'Warranty Expiry Period',
      key28: 'Details',
      key29: 'Edit',
      key30: 'Hourly CLB (Customer Load Baseline - kWh)',
      key30A: 'No registered DR activated devices.',
      key30B: 'Unknown',
      // Project
      key31: 'Project',
      key32: 'Register Project',
      key33: 'View All',
      key34: 'Total',
      key35: 'Units',
      key36: 'Newest First',
      key37: 'Oldest First',
      key38: 'Address',
      key39: 'Project Name',
      key40: 'Input',
      key41: 'View on Map',
      key42: 'No.',
      key43: 'Project Name',
      key44: 'Address',
      key45: 'Registration Date',
      key46: 'EMS',
      key47: 'Facility',
      key48: 'Edit',
      key49: 'Address',
      key50: 'Project',
      //프로젝트 등록
      key51: 'Project',
      key52: 'Register Project',
      key53: 'Project Name',
      key54: 'Please enter project name.',
      key55: 'Project Address',
      key56: 'Search project address.',
      key57: 'Search Address',
      key58: 'Business Registration Number',
      key59: 'Validate',
      key60: 'Facility List',
      key61: 'Save',
      // 마이 페이지
      key62: 'My Page',
      key63: 'Construction Company Information',
      key64: 'Company Name',
      key65: 'Company Contact',
      key66: 'Business Registration Certificate',
      key67: 'No Business Registration Certificate',
      key68: 'Business License',
      key69: 'Basic Information',
      key70: 'User ID',
      key71: 'Current Password',
      key72: 'New Password',
      key73: 'Confirm New Password',
      key74: 'Email Address',
      key76: 'Change',
      // 프로젝트 header
      key77: 'Carbon Reduction Amount',
      // EMS
      key78: 'Power System Status',
      key79: 'System Information',
      key80: 'Solar PV',
      key81: 'Power Devices',
      key82: 'Battery',
      key83: 'PV Power Consumption',
      key84: 'ESS Power Consumption',
      key85: 'Supply',
      key86: 'Charging',
      key87: 'Time',
      key88: 'Voltage',
      key89: 'Current',
      key90: 'Discharging',
      key91: 'Utilisation Rate',
      key92: 'Time/Weather',
      key93: 'Date',
      key94: 'Time',
      key95: 'Battery Specifications',
      key96: 'Capacity',
      key97: 'Units',
      key98: 'Solar Specifications',
      key99: 'Installed Capacity',
      key100: 'Units',
      key101: 'Power Device Specifications',
      key102: 'Power Consumption',
      key103: 'Units',
      key104: 'Solar PV',
      key105: 'Power Generation',
      key106: 'Utilisation Rate',
      key107: 'Daily Generation',
      key108: 'Power Devices',
      key109: 'Power Demand',
      key110: 'Daily Consumption',
      key111: 'Cumulative Consumption',
      key112: 'Battery',
      key113: 'Utilisation Rate',
      key114: 'Daily Charge Amount',
      key115: 'Daily Generation',
      key116: 'Daily Charging Time',
      key117: 'Daily Discharging Time',
      key118: 'Cumulative Charge Amount',
      key119: 'Cumulative Charging Time',
      key120: 'Cumulative Generation',
      key121: 'Cumulative Discharging Time',
      key122: 'Energy Status Monitoring',
      key123: 'Current',
      key124: 'Battery Charging',
      key125: 'Battery Discharging',
      key126: 'Actual Demand',
      key127: 'Actual PV Generation',
      // 시설   
      key128: 'Facility',
      key129: 'Power Plant',
      key130: 'Power Device',
      key131: 'Battery',
      // 시설 - 발전소
      key132: 'View All',
      key133: 'Total',
      key134: 'Units',
      key135: 'By Registration Date',
      key136: 'No.',
      key137: 'Power Plant Name',
      key138: 'Warranty Expiry Period',
      key139: 'Details',
      key140: 'Edit',
      // 시설 - 발전소 - 세부정보
      key141: 'Facility',
      key142: 'Power Plant Details',
      key143: 'Individual Module Power Control',
      key144: 'Inverter Data',
      key145: 'Facility Information',
      key146: 'Installed Capacity',
      key147: 'Cumulative Generation',
      key148: 'Construction Company Information',
      key149: 'Company Name',
      key150: 'Company Contact',
      key151: 'Generation Information',
      key152: 'Today’s Generation',
      key153: 'Previous Month Generation',
      key154: 'This Month Generation',
      key155: 'This Year Generation',
      key156: 'Cumulative Generation',
      key157: 'Today’s Generation Time',
      key158: 'Previous Month Generation Time',
      key159: 'This Month Generation Time',
      key160: 'This Year Generation Time',
      key161: 'Cumulative Generation Time',
      key162: 'Today’s Generation Revenue',
      key163: 'KRW',
      key164: 'Previous Month Revenue',
      key165: 'This Month Revenue',
      key166: 'This Year Revenue',
      key167: 'Cumulative Revenue',
      key168: 'Current Time',
      key169: 'Seconds',
      key170: 'Hourly Generation Graph (Unit: kWh)',
      key171: 'Generation',
      key172: 'This graph shows hourly generation data for today.',
      key173: 'Year',
      key174: 'Month',
      key175: 'Day',
      key176: 'Hour',
      key177: 'Daily Generation Graph (Unit: kWh)',
      key178: 'Generation',
      key179: 'This graph shows daily generation per hour over one month.',
      key180: 'Download File',
      key181: 'Single-Line Diagram File',
      key182: 'Drawing File',
      key183: 'Module Inverter Serial Number Excel File',
      key184: 'Basic Information',
      key185: 'Operation Start Date',
      key186: 'Business Owner Name',
      key187: 'Solar PV Information',
      key188: 'Solar Module',
      key189: 'Structure',
      key190: 'Electrical Work',
      // 시설 - 발전소 - 발전소 상세정보 - 개별 모듈 전원 제어
      key191: 'Facility Information',
      key192: 'Installed Capacity',
      key193: 'Cumulative Generation',
      key194: 'Construction Company Information',
      key195: 'Company Name',
      key196: 'Company Contact',
      key197: 'Upper',
      key198: 'Lower',
      key199: 'Not Operating',
      key200: 'Module Number',
      key201: 'Generation Efficiency',
      key202: 'Input',
      key203: 'Output',
      key204: 'Current',
      key205: 'Voltage',
      key206: 'Power',
      key207: 'Solar Module Layout',
      key208: 'Electrical Circuit Layout',
      key209: 'Real-Time Output by Inverter',
      key210: 'Issue Information',
      key211: 'Issue List',
      key212: 'Cause',
      key213: 'Enter Details',
      key214: 'Resolve',
      key215: 'Save and Close Issue',
      key216: 'Basic Information',
      key217: 'Operation Start Date',
      key218: 'Business Owner Name',
      key219: 'Solar PV Information',
      key220: 'Solar Module',
      key221: 'Structure',
      key222: 'Electrical Work',
      // 시설 - 전력기기
      key223: 'View All',
      key224: 'Total',
      key225: 'Units',
      key226: 'By Device',
      key227: 'By Power Consumption',
      key228: 'By Registration Date',
      key229: 'No.',
      key230: 'Device',
      key231: 'Type',
      key232: 'Power Device Name',
      key233: 'Model Name',
      key234: 'Power Consumption',
      key235: 'Warranty Expiry Period',
      key236: 'Details',
      key237: 'Edit',
      // 시설 - 전력기기 - 세부정보
      key238: 'Power Device Details',
      key239: 'Installation Location',
      key240: 'All Power Device Information',
      key241: 'Cumulative Power Consumption',
      key242: 'Today’s Power Consumption',
      key243: 'Overall Device Status',
      key244: 'Communication Status',
      key245: 'Normal',
      key246: 'Fault',
      key247: 'Communication Error',
      key248: 'Under Inspection',
      key249: '+DR',
      key250: '+DR Not Activated',
      key251: '+DR Activated',
      key252: 'Boiler',
      key253: 'Overall Power Management',
      key254: 'Heat Storage Tank Temperature',
      key255: 'Current Temperature',
      key256: 'Target Temperature',
      key257: 'Boiler Indoor Temperature',
      key258: '(Main/Representative)',
      key259: 'Current Temperature',
      key260: 'Target Temperature',
      key261: 'Boiler Generation Information',
      key262: 'Cumulative Power Consumption',
      key263: 'Cumulative Heating Energy',
      key264: 'Device Status',
      key265: 'Current Power Consumption',
      key266: 'Today’s Power Consumption',
      key267: 'Operating Mode',
      // 시설 - 전력기기 - 전력기기 추가 / 수정
      key268: 'Edit Power Device',
      key269: 'Power Device Type',
      key270: 'Boiler',
      key271: 'Power Device Name',
      key272: 'Model Name',
      key273: 'Power Consumption (kW)',
      key274: 'SITE Number',
      key275: 'Device Number',
      key276: 'Device Number',
      key277: 'RTU Number',
      key278: 'DR Resource Identifier',
      key279: 'Operation Start Date',
      key280: 'Select Date',
      key281: 'Service Warranty Period',
      key282: 'Select Date',
      key283: 'Control Items',
      key284: 'Power',
      key285: 'Temperature',
      key286: 'Emergency Shutdown',
      key287: 'Operating Mode',
      key288: 'Reservation',
      key289: '+DR (Demand Response)',
      key290: 'Select Connected Device',
      key291: 'No Connectable Power Devices Available.',
      key292: 'Please Select a Power Device.',
      key293: 'You can select power devices with matching Site ID and RTU ID',
      key294: 'Delete',
      key295: 'Power Device List',
      key296: 'Save',
      key297: 'Edit',
      // 시설 - 배터리
      key298: 'View All',
      key299: 'Total',
      key300: 'Units',
      key301: 'By Capacity',
      key302: 'By Registration Date',
      key303: 'No.',
      key304: 'Battery Name',
      key305: 'Battery Capacity',
      key306: 'Warranty Expiry Period',
      key307: 'Details',
      key308: 'Edit',
      // 시설 - 배터리 - 배터리 세부정보
      key309: 'Battery Details',
      key310: 'Graph Data',
      key311: 'Project Name',
      key312: 'Installation Location',
      key313: 'Installed Capacity',
      key314: 'Battery Information',
      key315: 'SYSTEM MODE',
      key316: 'MANUAL',
      key317: 'SYSTEM',
      key318: 'Charge/Discharge Mode',
      key319: 'Charging',
      key320: 'Discharging',
      key321: 'Communication Status',
      key322: 'Normal',
      key323: 'Error',
      key324: 'Charge/Discharge Mode FLOW (0.0~20.00 LPM)',
      key325: 'S-1-1 Salt NaCl Charging',
      key326: 'B-1-1 Base NaOH Charging',
      key327: 'A-1-1 Acid HCl Charging',
      key328: 'E-1 Electrolyte Na2SO4 Charging',
      key329: 'S-2-1 Salt NaCl Charging',
      key330: 'B-2-1 Base NaOH Charging',
      key331: 'A-2-1 Acid HCl Charging',
      key332: 'S-1-2 Salt NaCl Discharging',
      key333: 'B-1-2 Base NaOH Discharging',
      key334: 'A-1-2 Acid HCl Discharging',
      key335: 'E-1 Electrolyte Na2SO4 Discharging',
      key336: 'S-2-2 Salt NaCl Discharging',
      key337: 'B-2-2 Base NaOH Discharging',
      key338: 'A-2-2 Acid HCl Discharging',
      key339: 'Charge/Discharge Mode PRESSURE (0.0~30.0 bar)',
      key340: 'S-1-1 Salt NaCl Storage',
      key341: 'B-1-1 Base NaOH Storage',
      key342: 'A-1-1 Acid HCl Storage',
      key343: 'E-1 Electrolyte Na2SO4 Storage',
      key344: 'S-2-1 Salt NaCl Storage',
      key345: 'B-2-1 Base NaOH Storage',
      key346: 'A-2-1 Acid HCl Storage',
      key347: 'S-1-2 Salt NaCl Discharging',
      key348: 'B-1-2 Base NaOH Discharging',
      key349: 'A-1-2 Acid HCl Discharging',
      key350: 'E-1 Electrolyte Na2SO4 Discharging',
      key351: 'S-2-2 Salt NaCl Discharging',
      key352: 'B-2-2 Base NaOH Discharging',
      key353: 'A-2-2 Acid HCl Discharging',
      key354: 'PANEL Instantaneous Power',
      key355: 'PANEL Accumulated Power',
      key356: 'ED1 Charging Mode Voltage',
      key357: 'ED1 Charging Mode Current',
      key357A: 'ED1 Charging Mode Power Amount',
      key357B: 'ED1 Charging Mode Accumulated Power',
      key358: 'ED2 Discharging Mode Voltage',
      key359: 'ED2 Discharging Mode Current',
      key360: 'ED2 Discharging Mode Power Amount',
      key360A: 'ED2 Discharging Mode Accumulated Power',
      // 시설 - 배터리 등록 / 수정
      key361: 'Register Battery',
      key362: 'Edit Battery',
      key363: 'Battery Name',
      key364: 'Model Name',
      key365: 'Battery Capacity (kWh)',
      key366: 'SITE Number',
      key367: 'RTU Number',
      key368: 'Device Number',
      key369: 'Operation Start Date',
      key370: 'Select Date',
      key371: 'Service Warranty Period',
      key372: 'Select Date',
      key373: 'Control Items',
      key374: 'Power',
      key375: 'Temperature',
      key376: 'Emergency Shutdown',
      key377: 'Operating Mode',
      key378: 'Reservation',
      key379: 'Delete',
      key380: 'Battery List',
      key381: 'Save',
      // 인버터 데이터 그래프/리스트
      key382: 'Inverter Data Graph/List',
      key383: 'Hourly Generation (Statistics)',
      key384: 'View All',
      key385: 'Total',
      key386: 'Units',
      key387: 'Set Period',
      key388: 'Select',
      key389: 'DC, R/S/T Voltage',
      key390: 'DC, R/S/T Current',
      key391: 'Current (A)',
      key392: 'DC, Current Output',
      key393: 'Output (W)',
      key394: 'View as List',
      // 시간별 발전량(통계) 목록
      key395: 'Hourly Power Generation Statistics List',
      key396: 'View All',
      key397: 'Total',
      key398: 'Units',
      key399: 'Set Period',
      key400: 'Add',
      key401: 'No.',
      key402: 'Serial Number',
      key403: 'Date',
      key404: 'Time',
      key405: 'Generation (kWh)',
      key406: 'Edit',
      key407: 'Save',
      key408: 'No Results Found.',
      // 시설 - 발전소 - 등록 / 수정
      key409: 'Register Power Plant',
      key410: 'Edit Power Plant',
      key411: 'Power Plant Name',
      key412: 'Enter Power Plant Name',
      key413: 'Installed Capacity',
      key414: 'Number of Panels Installed',
      key415: 'Panels',
      key416: 'Layout Drawing',
      key417: 'No File Selected',
      key418: 'Select File',
      key419: 'Single-Line Diagram',
      key420: 'Module Inverter',
      key420A: 'Serial Number',
      key421: 'Download Form File',
      key422: 'Operation Start Date',
      key423: 'Select Date.',
      key424: 'Service Warranty Period',
      key425: 'SMP + REC',
      key425A: 'Price',
      key426: 'Per kW',
      key427: 'KRW',
      key428: 'Optimizer',
      key429: 'Usage Status',
      key430: 'Please register module layout, equipment, and communication info.',
      key431: 'Module Serial Number Match',
      key432: 'Equipment and Communication Info',
      key434: 'Delete',
      key435: 'Power Plant List',
      key436: 'Save',
      // 시설 - 발전소 등록 / 수정 - 모듈 시리얼 넘버 매치
      key437: 'All Power Plant List',
      key438: 'Register Standby Power Plant',
      key439: 'Load Serial Number',
      key440: 'Add Module Drawing',
      key441: 'Number of Rows',
      key442: 'Number of Columns',
      key443: 'Layout Selection',
      key444: 'Vertical Layout',
      key445: 'Horizontal Layout',
      key446: 'Azimuth',
      key447: 'Cancel',
      key448: 'Complete',
      key449: 'Delete Module',
      key450: 'Add Module',
      key451: 'Connection',
      key452: 'Find Serial Number',
      key453: 'Selection Complete',
      key454: 'Save',
      // Facility > Register/Edit Power Plant > Equipment & Communication Information
      key455: 'All Power Plant List',
      key456: 'Register Equipment & Communication Information',
      key457: 'Equipment List',
      key458: 'Material Information (Inverter)',
      key459: 'Inverter Number',
      key460: 'Inverter Name',
      key461: 'Inverter Manufacturer',
      key462: 'Inverter Capacity',
      key463: 'Module Name',
      key464: 'Module Manufacturer',
      key465: 'Module Output',
      key466: 'Number of Modules',
      key467: 'RTU Number',
      key468: 'RTU Numbers are inherited to all modules (optimisers) connected to the inverter (Default)',
      key469: 'Confirm',
      key470: 'Material Information (Module)',
      key471: 'Zigbee Number',
      key472: 'Optimizer Number',
      key473: 'RTU Number',
      key474: 'Confirm',

      // File Delete Button
      key475: 'Delete File',

      // Facility > Power Plant > Power Plant Details > Individual Module Power Control > Internal
      key476: 'Panel Temperature',
      key477: 'Input',
      key478: 'Output',
      key479: 'Current',
      key480: 'Voltage',
      key481: 'Power',
      key482: 'Real-Time Output by Inverter',
      key482A: '(All View)',
      key483: 'DC Voltage',
      key484: 'DC Current',
      key485: 'Phase R Voltage',
      key486: 'Phase R Current',
      key487: 'Phase S Voltage',
      key488: 'Phase S Current',
      key489: 'Phase T Voltage',
      key490: 'Phase T Current',

      // Battery Data Graph
      key491: 'Battery Data Graph',
      key492: 'View All',
      key493: 'Total',
      key494: 'Units',
      key495: 'Charge/Discharge Mode PRESSURE',

      // Alerts
      key496: 'Failed to Load Battery Information.',
      key497: 'Do you want to set all devices to "Under Inspection"?',
      key498: 'No',
      key499: 'Yes',
      key500: 'Operation Cancelled.',
      key501: 'No Temperature Data for This Device.',
      key502: 'The Minimum Target Temperature for This Device is ',
      key503: '°C.',
      key504: 'Please fill out this field.',
      key505: 'Please perform validation first.',
      key506: 'Invalid Business Registration Number.',
      key507: 'Notification',
      key508: 'Do you want to edit?',
      key509: 'No registered project exists.',

      // 프로젝트 등록/수정 추가분 
      key510: "Invalid business registration number.",
      key511: "Valid business registration number.",
      key512: "Do you want to save?",
      key513: "Notification",
      key514: "Please enter the project name.",
      key515: "Please enter the project address.",
      key516: "Please enter the business registration number.",
      key517: "The project name must be 36 characters or fewer.",
      key518: "Please perform validation first.",
      key519: "Please use the address search to enter the power plant address.",

      // 마이페이지 추가분
      key520: "The password is incorrect, so changes cannot be made.",
      key521: "Passwords do not match.",
      key522: "Current password is incorrect.",

      // EMS 추가분
      key523: "Failed to load battery information.",
      key524: "Failed to load power device information.",
      key525: "Failed to load carrier data.",
      key526: "Demand",
      key527: "Unit",
      key528: "Daily discharge amount",

      // 시설 추가분
      key529: "No registered facility exists.",
      key530: "No registered power device exists.",
      key531: "Unknown",
      key532: "No registered battery exists.",

      // 시설 - 발전소 상세 추가분 
      key533: "Cumulative power generation graph (Unit: kWh)",
      key534: "Monthly",
      key535: "Quarterly",
      key536: "Yearly",
      key537: "Panel",
      key538: "Unit",
      key539: "Galvanized steel",
      key540: "Text",

      // 시설 - 발전소 상세정보 추가분
      key541: "Power Plant Details",

      // 시설 - 발전소 상세정보 - 개별 모듈 전원 제어 추가분
      key542: "Zoom in",
      key543: "Reset",
      key544: "Zoom out",
      key545: "Do you want to turn off the power?",
      key546: "Power-off successful.",
      key547: "Do you want to turn on the power?",
      key548: "Power-on successful.",
      key549: "Circuit power management",
      key550: "DC Output",
      key551: "R-phase Output",
      key552: "S-phase Output",
      key553: "T-phase Output",

      // 시간별 발전량 (통계) 목록
      key554: "Please enter the new information and save.",
      key555: "Please enter the date correctly.",
      key556: "Please enter the power generation.",
      key557: "Do you want to add it?",
      key558: "Successfully added.",
      key559: "This data already exists.",
      key560: "Do you want to modify it?",
      key561: "Successfully modified.",
      key562: "Do you want to delete it?",
      key563: "Successfully deleted.",
      key564: "Inverter",
      key565: "All",
      key566: "Hour (time)",
      key567: "Detailed information",
      key568: "Time",
      key569: "Output",
      key570: "Cumulative power generation (kWh)",
      key571: "Frequency",
      key572: "Status code",

      // 발전소 추가 추가분 
      key573: "Cancelled.",
      key574: "Please enter the power plant name.",
      key575: "Please enter the installed capacity.",
      key576: "Please enter the number of installations.",
      key577: "Please enter the SMP + REC price.",
      key578: "Please enter the operation start date.",
      key579: "Please enter the service warranty period.",
      key580: "Please attach the inverter module serial number.",
      key581: "Please save temporarily and then move to the module layout screen.",
      key582: "Failed to delete the power plant.",

      // date picker 추가분
      key583: "Today",
      key584: "Yesterday",
      key585: "1 week ago",
      key586: "After 5 years",
      key587: "After 10 years",
      key588: "After 15 years",

      // Facility – Power Plant Registration / Edit – Module Serial Number Matching
      key589: "Find serial number",

      // Device & Communication Information
      key590: "Inverter",
      key591: "Module",
      key592: "Material information",

      // 전력기기 수정 등록
      key593: "Cancelled.",
      key594: "Please select the type of power device.",
      key595: "Please enter the power device name.",
      key596: "Please enter the model name.",
      key597: "Please enter the power consumption.",
      key598: "Please enter the site number.",
      key599: "Please enter the device number.",
      key600: "Please enter the RTU number.",
      key601: "Please enter the operation start date.",
      key602: "Please enter the service warranty period.",
      key603: "If +DR (Demand Response) is checked, a DR resource identifier is required. Please enter the DR resource identifier.",
      key604: "Register power device",
      key605: "Additional device type required",
      key606: "Please enter the power device name.",

      // 전력기기 상세정보
      key607: "Failed to set boiler target temperature.",
      key608: "Do you want to turn off?",
      key609: "Do you want to turn on?",
      key610: "Yes",
      key611: "No",
      key612: "Successfully executed.",
      key613: "Operation cancelled.",
      key614: "Failed in individual power control.",
      key615: "All power",
      key616: "Failed in total power control.",
      key617: "No temperature data for this device.",
      key618: "Temperature adjustment is not available for this device.",
      key619: "Target temperature of this device is",
      key620: "Minimum",
      key621: "Maximum",
      key622: "°C",
      key623: "Do you want to cancel device inspection mode?",
      key624: "Set all devices to inspection mode?",
      key625: "(Sub)",
      key626: "Hourly power consumption graph (Unit: kWh)",
      key627: "Power consumption",
      key628: "Daily power consumption graph (Unit: kWh)",
      key629: "Cumulative power consumption graph (Unit: kWh)",
      key630: "Monthly",
      key631: "Quarterly",
      key632: "Yearly",

      // 배터리 추가 수정
      key633: "Please enter the battery name.",
      key634: "Please enter the model name.",
      key635: "Please enter the battery capacity.",
      key636: "Please enter the site number.",
      key637: "Please enter the RTU number.",
      key638: "Please enter the device number.",
      key639: "Please enter the operation start date.",
      key640: "Please enter the service warranty period.",
      key641: "Cancelled.",

      // 배터리 상세
      key642: "Failed to load battery information.",
      key643: "S-1 Salt NaCl",
      key644: "B-1 Base NaOH",
      key645: "A-1 Acid HCl",
      key646: "E-1 Electrolyte Na2SO4",
      key647: "S-2 Salt NaCl",
      key648: "B-2 Base NaOH",
      key649: "A-2 Acid HCl",
      key650: "Drain",
      key651: "S-1 Salt NaCl",
      key652: "B-1 Base NaOH",
      key653: "A-1 Acid HCl",
      key654: "E-1 Electrolyte Na2SO4",
      key655: "S-2 Salt NaCl",
      key656: "B-2 Base NaOH",
      key657: "A-2 Acid HCl",
      key658: "Tank pH (0.0 ~ 14.0 pH)",
      key659: "Tank Conductivity (0.0 ~ 500.0 ms)",
      key660: "Charge/Discharge Mode Flow",
      ...auth.en,
      ...ems.en,
      ...inverterDetail.en
    }
  },
  vi: {
    translation: {
      // Header
      key1: 'Dự án',
      key2: 'Trang cá nhân',
      key3: 'Đăng xuất',
      // main
      key4: {
        line1: 'Thông qua phân tích máy học và công nghệ dự đoán sản lượng,',
        line2: 'hệ thống dự đoán sản lượng điện của từng mô-đun theo thời gian thực,',
        line3: 'phát hiện tình trạng phát điện và tối ưu hóa hiệu suất.',
      },
      // Footer
      key5: 'Chính sách bảo mật',
      key6: 'Điều khoản sử dụng',
      // +DR
      key7: 'Thông tin thiết bị +DR đã kích hoạt',
      key8: 'Tổng số thiết bị +DR',
      key9: 'Thiết bị +DR đang hoạt động',
      key9A: 'Thiết bị +DR dự kiến hoạt động',
      key10: 'Biểu đồ sử dụng điện theo giờ (kWh)',
      key11: 'Lịch sử kích hoạt +DR',
      key12: 'Ngày phát lệnh',
      key13: 'Số thiết bị đã kích hoạt',
      key14: 'Danh sách toàn bộ thiết bị tham gia DR',
      key15: 'Thiết bị +DR đã kích hoạt',
      key16: 'Thiết bị +DR chưa kích hoạt',
      key17: 'Tổng cộng',
      key18: 'mục',
      key19: 'Theo thiết bị',
      key20: 'Theo mức tiêu thụ điện',
      key21: 'Theo ngày đăng ký',
      key21A: 'Số thứ tự',
      key22: 'Thiết bị',
      key23: 'Loại',
      key24: 'Tên thiết bị điện',
      key25: 'Tên MODEL',
      key26: 'Điện năng tiêu thụ',
      key27: 'Thời hạn bảo hành',
      key28: 'Chi tiết',
      key29: 'Chỉnh sửa',
      key30: 'CLB theo giờ (Mức tải chuẩn của khách hàng - kWh)',
      key30A: 'Không có thiết bị DR đã kích hoạt nào được đăng ký.',
      key30B: 'Không rõ',
      //프로젝트 
      key31: 'Dự án',
      key32: 'Đăng ký dự án',
      key33: 'Xem tất cả',
      key34: 'Tổng cộng',
      key35: 'Thiết bị',
      key36: 'Mới nhất trước',
      key37: 'Cũ nhất trước',
      key38: 'Địa chỉ',
      key39: 'Tên dự án',
      key40: 'Nhập',
      key41: 'Xem trên bản đồ',
      key42: 'Số thứ tự',
      key43: 'Tên dự án',
      key44: 'Địa chỉ',
      key45: 'Ngày đăng ký',
      key46: 'EMS',
      key47: 'Cơ sở hạ tầng',
      key48: 'Chỉnh sửa',
      key49: 'Địa chỉ',
      key50: 'Dự án',
      // 프로젝트 등록
      key51: 'Dự án',
      key52: 'Đăng ký dự án',
      key53: 'Tên dự án',
      key54: 'Nhập tên dự án.',
      key55: 'Địa chỉ dự án',
      key56: 'Tìm kiếm địa chỉ dự án.',
      key57: 'Tìm địa chỉ',
      key58: 'Mã số doanh nghiệp',
      key59: 'Kiểm tra hợp lệ',
      key60: 'Danh sách cơ sở',
      key61: 'Lưu',
      // 마이 페이지
      key62: 'Trang cá nhân',
      key63: 'Thông tin công ty thi công',
      key64: 'Tên công ty thi công',
      key65: 'Liên hệ công ty thi công',
      key66: 'Giấy chứng nhận đăng ký kinh doanh',
      key67: 'Không có giấy chứng nhận đăng ký kinh doanh',
      key68: 'Giấy phép kinh doanh',
      key69: 'Thông tin cơ bản',
      key70: 'Tài khoản',
      key71: 'Mật khẩu hiện tại',
      key72: 'Mật khẩu mới',
      key73: 'Xác nhận mật khẩu mới',
      key74: 'Địa chỉ email',
      key76: 'Thay đổi',
      // 프로젝트 header
      key77: 'Lượng giảm phát thải carbon',
      // EMS
      key78: 'Tình trạng hệ thống điện',
      key79: 'Thông tin hệ thống',
      key80: 'Điện mặt trời',
      key81: 'Thiết bị điện',
      key82: 'Pin',
      key83: 'Điện năng tiêu thụ trực tiếp từ PV',
      key84: 'Điện năng tiêu thụ từ ESS - Hệ thống lưu trữ năng lượng',
      key85: 'Cung cấp',
      key86: 'Sạc',
      key87: 'Thời gian',
      key88: 'Điện áp',
      key89: 'Dòng điện',
      key90: 'Xả',
      key91: 'Tỷ lệ vận hành',
      key92: 'Thời gian/Thời tiết',
      key93: 'Ngày',
      key94: 'Giờ',
      key95: 'Thông số kỹ thuật của Battery',
      key96: 'Dung lượng',
      key97: 'Số lượng',
      key98: 'Thông số kỹ thuật điện mặt trời',
      key99: 'Công suất lắp đặt',
      key100: 'Số lượng',
      key101: 'Thông số thiết bị điện',
      key102: 'Điện năng tiêu thụ',
      key103: 'Số lượng',
      key104: 'Năng lượng mặt trời',
      key105: 'Sản lượng điện',
      key106: 'Tỷ lệ vận hành',
      key107: 'Sản lượng điện hàng ngày',
      key108: 'Thiết bị điện',
      key109: 'Nhu cầu điện',
      key110: 'Lượng tiêu thụ hàng ngày',
      key111: 'Lượng tiêu thụ tích lũy',
      key112: 'Pin',
      key113: 'Tỷ lệ vận hành',
      key114: 'Lượng sạc hàng ngày',
      key115: 'Sản lượng điện hàng ngày',
      key116: 'Thời gian sạc hàng ngày',
      key117: 'Thời gian xả hàng ngày',
      key118: 'Lượng sạc tích lũy',
      key119: 'Thời gian sạc tích lũy',
      key120: 'Sản lượng điện tích lũy',
      key121: 'Thời gian xả tích lũy',
      key122: 'Giám sát trạng thái năng lượng',
      key123: 'Hiện tại',
      key124: 'Battery đang sạc',
      key125: 'Battery đang xả',
      key126: 'Nhu cầu thực tế',
      key127: 'Sản lượng điện mặt trời thực tế',
      // 시설
      key128: 'Cơ sở',
      key129: 'Nhà máy điện',
      key130: 'Thiết bị điện',
      key131: 'Pin',
      // 시설 - 발전소
      key132: 'Xem tất cả',
      key133: 'Tổng cộng',
      key134: 'Thiết bị',
      key135: 'Theo ngày đăng ký',
      key136: 'Số thứ tự',
      key137: 'Tên nhà máy điện',
      key138: 'Thời hạn bảo hành',
      key139: 'Chi tiết',
      key140: 'Chỉnh sửa',
      // 시설 - 발전소 - 세부정보
      key141: 'Cơ sở',
      key142: 'Chi tiết nhà máy điện',
      key143: 'Điều khiển nguồn điện từng mô-đun riêng lẻ',
      key144: 'Dữ liệu Inverter',
      key145: 'Thông tin thiết bị',
      key146: 'Công suất lắp đặt',
      key147: 'Tổng sản lượng phát điện',
      key148: 'Thông tin công ty thi công',
      key149: 'Tên công ty thi công',
      key150: 'Liên hệ công ty thi công',
      key151: 'Thông tin phát điện',
      key152: 'Sản lượng điện hôm nay',
      key153: 'Sản lượng điện tháng trước',
      key154: 'Sản lượng điện tháng này',
      key155: 'Sản lượng điện năm nay',
      key156: 'Sản lượng điện tích lũy',
      key157: 'Thời gian phát điện hôm nay',
      key158: 'Thời gian phát điện tháng trước',
      key159: 'Thời gian phát điện tháng này',
      key160: 'Thời gian phát điện năm nay',
      key161: 'Thời gian phát điện tích lũy',
      key162: 'Doanh thu phát điện hôm nay',
      key163: 'Won (KRW)',
      key164: 'Doanh thu phát điện tháng trước',
      key165: 'Doanh thu phát điện tháng này',
      key166: 'Doanh thu phát điện năm nay',
      key167: 'Doanh thu phát điện tích luỹ',
      key168: 'Thời gian hiện tại',
      key169: 'Giây',
      key170: 'Biểu đồ sản lượng phát điện theo giờ (kWh)',
      key171: 'Sản lượng điện',
      key172: 'Biểu đồ này cung cấp thông tin sản lượng điện phát theo từng giờ trong ngày.',
      key173: 'Năm',
      key174: 'Tháng',
      key175: 'Ngày',
      key176: 'Giờ',
      key177: 'Biểu đồ sản lượng phát điện theo ngày (kWh)',
      key178: 'Sản lượng điện',
      key179: 'Biểu đồ này cung cấp thông tin sản lượng phát điện theo ngày trong một tháng.',
      key180: 'Tải xuống tập tin',
      key181: 'Tập tin sơ đồ đơn tuyến',
      key182: 'Tập tin bản vẽ',
      key183: 'Tập tin Excel số serial mô-đun inverter',
      key184: 'Thông tin cơ bản',
      key185: 'Ngày bắt đầu vận hành',
      key186: 'Tên chủ doanh nghiệp',
      key187: 'Thông tin năng lượng mặt trời',
      key188: 'Mô-đun năng lượng mặt trời',
      key189: 'Kết cấu',
      key190: 'Công trình điện',
      // 시설 - 발전소 - 발전소 상세정보 - 개별 모듈 전원 제어
      key191: 'Thông tin về cơ sở',
      key192: 'Công suất lắp đặt',
      key193: 'Tổng sản lượng phát điện',
      key194: 'Thông tin công ty thi công',
      key195: 'Tên công ty thi công',
      key196: 'Liên hệ công ty thi công',
      key197: 'Cấp trên',
      key198: 'Cấp dưới',
      key199: 'Không vận hành',
      key200: 'Số mô-đun',
      key201: 'Hiệu suất phát điện',
      key202: 'Đầu vào',
      key203: 'Đầu ra',
      key204: 'Dòng điện',
      key205: 'Điện áp',
      key206: 'Công suất',
      key207: 'Sơ đồ bố trí mô-đun năng lượng mặt trời',
      key208: 'Sơ đồ mạch điện',
      key209: 'Sản lượng thời gian thực theo inverter',
      key210: 'Thông tin sự cố',
      key211: 'Danh sách sự cố',
      key212: 'Nguyên nhân',
      key213: 'Nhập nội dung',
      key214: 'Khắc phục',
      key215: 'Lưu và đóng sự cố',
      key216: 'Thông tin cơ bản',
      key217: 'Ngày bắt đầu vận hành',
      key218: 'Tên chủ dự án',
      key219: 'Thông tin năng lượng mặt trời',
      key220: 'Mô-đun năng lượng mặt trời',
      key221: 'Kết cấu',
      key222: 'Công trình điện',
      // 시설 - 전력기기
      key223: 'Xem tất cả',
      key224: 'Tổng cộng',
      key225: 'Thiết bị',
      key226: 'Theo thiết bị',
      key227: 'Theo điện năng tiêu thụ',
      key228: 'Theo ngày đăng ký',
      key229: 'Số thứ tự',
      key230: 'Thiết bị',
      key231: 'Loại',
      key232: 'Tên thiết bị điện',
      key233: 'Tên Model',
      key234: 'Điện năng tiêu thụ',
      key235: 'Thời hạn bảo hành',
      key236: 'Chi tiết',
      key237: 'Chỉnh sửa',
      // 시설 - 전력기기 - 세부정보
      key238: 'Chi tiết thiết bị điện',
      key239: 'Vị trí lắp đặt',
      key240: 'Thông tin toàn bộ thiết bị điện',
      key241: 'Công suất tiêu thụ tích lũy',
      key242: 'Công suất tiêu thụ hôm nay',
      key243: 'Tình trạng thiết bị tổng thể',
      key244: 'Tình trạng kết nối',
      key245: 'Bình thường',
      key246: 'Hỏng',
      key247: 'Lỗi kết nối',
      key248: 'Đang kiểm tra',
      key249: '+DR',
      key250: '+DR chưa kích hoạt',
      key251: '+DR đã kích hoạt',
      key252: 'Nồi hơi (Boiler)',
      key253: 'Quản lý nguồn tổng thể',
      key254: 'Nhiệt độ tích trữ bồn chứa nhiệt',
      key255: 'Nhiệt độ hiện tại',
      key256: 'Nhiệt độ mục tiêu',
      key257: 'Nhiệt độ trong nồi hơi',
      key258: '(Chính/Đại diện)',
      key259: 'Nhiệt độ hiện tại',
      key260: 'Nhiệt độ mục tiêu',
      key261: 'Thông tin phát điện của nồi hơi',
      key262: 'Điện năng tiêu thụ tích luỹ',
      key263: 'Nhiệt lượng sưởi ấm tích luỹ',
      key264: 'Tình trạng thiết bị',
      key265: 'Điện năng tiêu thụ hiện tại',
      key266: 'Điện năng tiêu thụ hôm nay',
      key267: 'Chế độ vận hành',
      // 시설 - 전력기기 - 전력기기 추가 / 수정
      key268: 'Chỉnh sửa thiết bị điện',
      key269: 'Loại thiết bị điện',
      key270: 'Nồi hơi (Boiler)',
      key271: 'Tên thiết bị điện',
      key272: 'Tên Model',
      key273: 'Điện năng/Công suất tiêu thụ (kW)',
      key274: 'Số SITE',
      key275: 'Số thiết bị',
      key276: 'Số thiết bị',
      key277: 'Số RTU',
      key278: 'Mã nhận diện tài nguyên DR',
      key279: 'Ngày bắt đầu vận hành',
      key280: 'Chọn ngày',
      key281: 'Thời hạn bảo hành dịch vụ',
      key282: 'Chọn ngày',
      key283: 'Mục điều khiển',
      key284: 'Nguồn điện',
      key285: 'Nhiệt độ',
      key286: 'Ngắt khẩn cấp',
      key287: 'Chế độ vận hành',
      key288: 'Đặt trước',
      key289: '+DR (Đáp ứng nhu cầu điện)',
      key290: 'Chọn thiết bị kết nối',
      key291: 'Không có thiết bị điện khả dụng để kết nối.',
      key292: 'Vui lòng chọn thiết bị điện.',
      key293: 'Chỉ có thể chọn thiết bị điện có số SITE và số RTU trùng khớp',
      key294: 'Xóa',
      key295: 'Danh sách thiết bị điện',
      key296: 'Lưu',
      key297: 'Chỉnh sửa',
      // 시설 - 배터리
      key298: 'Xem tất cả',
      key299: 'Tổng cộng',
      key300: 'Thiết bị',
      key301: 'Theo dung lượng',
      key302: 'Theo ngày đăng ký',
      key303: 'Số thứ tự',
      key304: 'Tên pin lưu trữ',
      key305: 'Dung lượng pin',
      key306: 'Thời hạn bảo hành',
      key307: 'Chi tiết',
      key308: 'Chỉnh sửa',
      // 시설 - 배터리 - 배터리 세부정보key309: 'Chi tiết pin lưu trữ',
      key310: 'Dữ liệu biểu đồ',
      key311: 'Tên dự án',
      key312: 'Vị trí lắp đặt',
      key313: 'Công suất lắp đặt',
      key314: 'Thông tin pin lưu trữ',
      key315: 'CHẾ ĐỘ HỆ THỐNG',
      key316: 'Chế độ THỦ CÔNG',
      key317: 'HỆ THỐNG',
      key318: 'Chế độ sạc/xả',
      key319: 'Sạc',
      key320: 'Xả',
      key321: 'Tình trạng kết nối',
      key322: 'Bình thường',
      key323: 'Lỗi',
      key324: 'Chế độ sạc/xả (0.0~20.00 LPM)',
      key325: 'S-1-1 Muối NaCl Đang sạc',
      key326: 'B-1-1 Bazơ NaOH Đang sạc',
      key327: 'A-1-1 Axit HCl Đang sạc',
      key328: 'E-1 Điện phân Na2SO4 Đang sạc',
      key329: 'S-2-1 Muối NaCl Đang sạc',
      key330: 'B-2-1 Bazơ NaOH Đang sạc',
      key331: 'A-2-1 Axit HCl Đang sạc',
      key332: 'S-1-2 Muối NaCl Đang xả',
      key333: 'B-1-2 Bazơ NaOH Đang xả',
      key334: 'A-1-2 Axit HCl Đang xả',
      key335: 'E-1 Điện phân Na2SO4 Đang xả',
      key336: 'S-2-2 Muối NaCl Đang xả',
      key337: 'B-2-2 Bazơ NaOH Đang xả',
      key338: 'A-2-2 Axit HCl Đang xả',
      key339: 'Áp suất chế độ Sạc/Xả (0.0~30.0 bar)',
      key340: 'S-1-1 Muối NaCl Tích điện',
      key341: 'B-1-1 Bazơ NaOH Tích điện',
      key342: 'A-1-1 Axit HCl Tích điện',
      key343: 'E-1 Điện phân Na2SO4 Tích điện',
      key344: 'S-2-1 Muối NaCl Tích điện',
      key345: 'B-2-1 Bazơ NaOH Tích điện',
      key346: 'A-2-1 Axit HCl Tích điện',
      key347: 'S-1-2 Muối NaCl Đang xả',
      key348: 'B-1-2 Bazơ NaOH Đang xả',
      key349: 'A-1-2 Axit HCl Đang xả',
      key350: 'E-1 Điện phân Na2SO4 Đang xả',
      key351: 'S-2-2 Muối NaCl Đang xả',
      key352: 'B-2-2 Bazơ NaOH Đang xả',
      key353: 'A-2-2 Axit HCl Đang xả',
      key354: 'Công suất tức thời của tấm pin',
      key355: 'Lượng điện tích lũy của tấm pin',
      key356: 'Điện áp chế độ đang sạc ED1',
      key357: 'Dòng điện chế độ đang sạc ED1',
      key357A: 'Lượng điện chế độ đang sạc ED1',
      key357B: 'Lượng điện tích lũy chế độ đang sạc ED1',
      key358: 'Điện áp chế độ đang xả ED2',
      key359: 'Dòng điện chế độ đang xả ED2',
      key360: 'Lượng điện chế độ đang xả ED2',
      key360A: 'Lượng điện tích lũy chế độ đang xả ED2',
      // 시설 - 배터리 등록 / 수정
      key361: 'Đăng ký pin lưu trữ',
      key362: 'Chỉnh sửa pin lưu trữ',
      key363: 'Tên pin lưu trữ',
      key364: 'Tên MODEL',
      key365: 'Dung lượng pin (kWh)',
      key366: 'Số SITE',
      key367: 'Số RTU',
      key368: 'Số thiết bị',
      key369: 'Ngày bắt đầu vận hành',
      key370: 'Chọn ngày',
      key371: 'Thời hạn bảo hành dịch vụ',
      key372: 'Chọn ngày',
      key373: 'Mục điều khiển',
      key374: 'Nguồn điện',
      key375: 'Nhiệt độ',
      key376: 'Ngắt khẩn cấp',
      key377: 'Chế độ vận hành',
      key378: 'Đặt trước',
      key379: 'Xóa',
      key380: 'Danh sách pin lưu trữ',
      key381: 'Lưu',
      // 인버터 데이터 그래프/리스트
      key382: 'Biểu đồ/Danh sách dữ liệu inverter',
      key383: 'Sản lượng phát điện theo giờ (thống kê)',
      key384: 'Xem tất cả',
      key385: 'Tổng cộng',
      key386: 'Thiết bị',
      key387: 'Cài đặt khoảng thời gian',
      key388: 'Lựa chọn',
      key389: 'Điện áp DC, R/S/T',
      key390: 'Dòng điện DC, R/S/T',
      key391: 'Dòng điện (A)',
      key392: 'Công suất đầu ra DC hiện tại',
      key393: 'Công suất đầu ra (W)',
      key394: 'Xem dạng danh sách',
      // 시간별 발전량(통계) 목록
      key395: 'Danh sách thống kê sản lượng phát điện theo giờ',
      key396: 'Xem tất cả',
      key397: 'Tổng cộng',
      key398: 'Thiết bị',
      key399: 'Cài đặt khoảng thời gian',
      key400: 'Thêm',
      key401: 'Số thứ tự',
      key402: 'Số serial',
      key403: 'Ngày',
      key404: 'Giờ',
      key405: 'Sản lượng (kWh)',
      key406: 'Chỉnh sửa',
      key407: 'Lưu',
      key408: 'Không có kết quả tìm thấy.',
      // 시설 - 발전소 - 등록 / 수정
      key409: 'Đăng ký nhà máy điện',
      key410: 'Chỉnh sửa nhà máy điện',
      key411: 'Tên nhà máy điện',
      key412: 'Vui lòng nhập tên nhà máy điện',
      key413: 'Công suất lắp đặt',
      key414: 'Số lượng tấm lắp đặt',
      key415: 'Tấm pin',
      key416: 'Sơ đồ bố trí',
      key417: 'Không có tập tin được chọn',
      key418: 'Chọn tập tin',
      key419: 'Sơ đồ đơn tuyến',
      key420: 'Số serial',
      key420A: 'mô-đun inverter',
      key421: 'Tải xuống tập tin mẫu',
      key422: 'Ngày bắt đầu vận hành',
      key423: 'Chọn ngày.',
      key424: 'Thời hạn bảo hành dịch vụ',
      key425: 'Giá',
      key425A: 'SMP + REC',
      key426: 'Trên mỗi kW',
      key427: 'Won (KRW)',
      key428: 'Optimizer - Bộ tối ưu hoá công suất',
      key429: 'Tình trạng sử dụng',
      key430: 'Vui lòng đăng ký bố trí mô-đun, thiết bị và thông tin kết nối.',
      key431: 'Khớp số serial mô-đun',
      key432: 'Thông tin thiết bị và kết nối',
      key434: 'Xóa',
      key435: 'Danh sách nhà máy điện',
      key436: 'Lưu',
      // 시설 - 발전소 등록 / 수정 - 모듈 시리얼 넘버 매치
      key437: 'Danh sách toàn bộ nhà máy điện',
      key438: 'Đăng ký nhà máy điện đang chờ',
      key439: 'Tải số serial',
      key440: 'Thêm bản vẽ mô-đun',
      key441: 'Số hàng',
      key442: 'Số cột',
      key443: 'Lựa chọn bố trí',
      key444: 'Bố trí dọc',
      key445: 'Bố trí ngang',
      key446: 'Góc phương vị',
      key447: 'Hủy',
      key448: 'Hoàn tất',
      key449: 'Xóa mô-đun',
      key450: 'Thêm mô-đun',
      key451: 'Kết nối',
      key452: 'Tìm số serial',
      key453: 'Hoàn tất lựa chọn',
      key454: 'Lưu',
      // 시설 - 발전소 등록 / 수정 - 장비 및 통신 정보
      key455: 'Danh sách toàn bộ nhà máy điện',
      key456: 'Đăng ký thông tin thiết bị và kết nối',
      key457: 'Danh sách thiết bị',
      key458: 'Thông tin vật tư (Biến tần - Inverter)',
      key459: 'Số inverter',
      key460: 'Tên inverter',
      key461: 'Hãng sản xuất inverter',
      key462: 'Công suất inverter',
      key463: 'Tên mô-đun',
      key464: 'Hãng sản xuất mô-đun',
      key465: 'Công suất mô-đun',
      key466: 'Số lượng mô-đun',
      key467: 'Số RTU',
      key468: 'Số RTU sẽ được gán cho tất cả mô-đun (tối ưu hóa) kết nối với inverter này (mặc định)',
      key469: 'Xác nhận',
      key470: 'Thông tin vật tư (Mô-đun)',
      key471: 'Số Zigbee',
      key472: 'Số Optimizer',
      key473: 'Số RTU',
      key474: 'Xác nhận',

      // 파일 삭제 버튼
      key475: 'Xóa tệp tin',

      // 시설 - 발전소 - 발전소 상세정보 - 개별 모듈 전원 제어 - 내부
      key476: 'Nhiệt độ tấm pin',
      key477: 'Đầu vào',
      key478: 'Đầu ra',
      key479: 'Dòng điện',
      key480: 'Điện áp',
      key481: 'Công suất điện',
      key482: 'Sản lượng theo thời gian thực từng inverter',
      key482A: '(Xem toàn bộ)',
      key483: 'Điện áp DC',
      key484: 'Dòng điện DC',
      key485: 'Điện áp pha R',
      key486: 'Dòng điện pha R',
      key487: 'Điện áp pha S',
      key488: 'Dòng điện pha S',
      key489: 'Điện áp pha T',
      key490: 'Dòng điện pha T',
      // 배터리 데이터 그래프
      key491: 'Biểu đồ dữ liệu pin',
      key492: 'Xem tất cả',
      key493: 'Tổng cộng',
      key494: 'Thiết bị',
      key495: 'Áp suất sạc/xả',

      // 모달 / 알럿
      key496: 'Không tải được thông tin pin',
      key497: 'Bạn có muốn đặt tất cả thiết bị ở trạng thái "Đang kiểm tra" không?',
      key498: 'Không',
      key499: 'Có',
      key500: 'Tác vụ đã bị hủy.',
      key501: 'Không có dữ liệu nhiệt độ cho thiết bị này.',
      key502: 'Nhiệt độ mục tiêu tối thiểu của thiết bị này là ',
      key503: '°C.',
      key504: 'Vui lòng điền vào trường này.',
      key505: 'Vui lòng thực hiện kiểm tra hợp lệ trước.',
      key506: 'Mã số doanh nghiệp không hợp lệ.',
      key507: 'Thông báo',
      key508: 'Bạn có muốn chỉnh sửa không?',
      key509: 'Không có dự án nào đã được đăng ký.',

      //프로젝트 등록/수정 추가분
      key510: "Số đăng ký kinh doanh không hợp lệ.",
      key511: "Số đăng ký kinh doanh hợp lệ.",
      key512: "Bạn có muốn lưu không?",
      key513: "Thông báo",
      key514: "Vui lòng nhập tên dự án.",
      key515: "Vui lòng nhập địa chỉ dự án.",
      key516: "Vui lòng nhập số đăng ký kinh doanh.",
      key517: "Tên dự án phải ít hơn hoặc bằng 36 ký tự.",
      key518: "Vui lòng thực hiện kiểm tra tính hợp lệ trước.",
      key519: "Vui lòng sử dụng chức năng tìm kiếm để nhập địa chỉ nhà máy điện.",

      // 마이페이지 추가분
      key520: "Mật khẩu không đúng nên không thể thay đổi.",
      key521: "Mật khẩu không khớp.",
      key522: "Mật khẩu hiện tại không chính xác.",

      // EMS 추가분
      key523: "Không thể tải thông tin pin.",
      key524: "Không thể tải thông tin thiết bị điện.",
      key525: "Không thể tải dữ liệu truyền dẫn.",
      key526: "Nhu cầu",
      key527: "Cái",
      key528: "Lượng xả hàng ngày",

      // 시설 추가분
      key529: "Không tồn tại cơ sở năng lượng đã đăng ký.",
      key530: "Không tồn tại thiết bị điện đã đăng ký.",
      key531: "Không xác định",
      key532: "Không tồn tại pin đã đăng ký.",

      // 시설 - 발전소 상세 추가분 
      key533: "Biểu đồ sản lượng phát điện lũy kế (Đơn vị: kWh)",
      key534: "Hàng tháng",
      key535: "Hàng quý",
      key536: "Hàng năm",
      key537: "Tấm pin",
      key538: "Thiết bị",
      key539: "Thép mạ kẽm",
      key540: "Text",

      // 시설 - 발전소 상세정보 추가분
      key541: "Thông tin chi tiết nhà máy điện",

      // 시설 - 발전소 상세정보 - 개별 모듈 전원 제어 추가분
      key542: "Phóng to",
      key543: "Khôi phục mặc định",
      key544: "Thu nhỏ",
      key545: "Bạn có muốn tắt nguồn không?",
      key546: "Tắt nguồn thành công.",
      key547: "Bạn có muốn bật nguồn không?",
      key548: "Bật nguồn thành công.",
      key549: "Quản lý nguồn mạch điện",
      key550: "Ngõ ra DC",
      key551: "Ngõ ra pha R",
      key552: "Ngõ ra pha S",
      key553: "Ngõ ra pha T",

      // 시간별 발전량 (통계) 목록
      key554: "Vui lòng nhập thông tin mới và lưu lại.",
      key555: "Vui lòng nhập ngày chính xác.",
      key556: "Vui lòng nhập sản lượng phát điện.",
      key557: "Bạn có muốn thêm không?",
      key558: "Đã thêm thành công.",
      key559: "Dữ liệu này đã tồn tại.",
      key560: "Bạn có muốn chỉnh sửa không?",
      key561: "Chỉnh sửa thành công.",
      key562: "Bạn có muốn xóa không?",
      key563: "Xóa thành công.",
      key564: "Bộ biến tần (Inverter)",
      key565: "Tất cả",
      key566: "Giờ (thời gian)",
      key567: "Thông tin chi tiết",
      key568: "Thời gian",
      key569: "Công suất đầu ra",
      key570: "Sản lượng phát điện lũy kế (kWh)",
      key571: "Tần số",
      key572: "Mã trạng thái",

      // 발전소 추가 추가분 
      key573: "Đã hủy.",
      key574: "Vui lòng nhập tên nhà máy điện.",
      key575: "Vui lòng nhập công suất lắp đặt.",
      key576: "Vui lòng nhập số lượng lắp đặt.",
      key577: "Vui lòng nhập giá SMP + REC.",
      key578: "Vui lòng nhập ngày bắt đầu vận hành.",
      key579: "Vui lòng nhập thời hạn bảo hành dịch vụ.",
      key580: "Vui lòng đính kèm số sê-ri của mô-đun inverter.",
      key581: "Vui lòng lưu tạm thời và chuyển đến màn hình bố trí mô-đun.",
      key582: "Xóa nhà máy điện không thành công.",

      // date picker 추가분
      key583: "Hôm nay",
      key584: "Hôm qua",
      key585: "1 tuần trước",
      key586: "Sau 5 năm",
      key587: "Sau 10 năm",
      key588: "Sau 15 năm",

      // Cơ sở năng lượng – Đăng ký / Chỉnh sửa nhà máy điện – Ghép số sê-ri mô-đun
      key589: "Tìm số sê-ri",
      // Thiết bị & Thông tin kết nối
      key590: "Inverter (biến tần)",
      key591: "Mô-đun (tấm pin mặt trời)",
      key592: "Thông tin vật tư",

      // 전력기기 수정 등록
      key593: "Đã hủy.",
      key594: "Vui lòng chọn loại thiết bị điện.",
      key595: "Vui lòng nhập tên thiết bị điện.",
      key596: "Vui lòng nhập tên model.",
      key597: "Vui lòng nhập công suất tiêu thụ.",
      key598: "Vui lòng nhập số site.",
      key599: "Vui lòng nhập số thiết bị.",
      key600: "Vui lòng nhập số RTU.",
      key601: "Vui lòng nhập ngày bắt đầu vận hành.",
      key602: "Vui lòng nhập thời hạn bảo hành dịch vụ.",
      key603: "Nếu chọn +DR (Phản ứng nhu cầu), bắt buộc phải có mã định danh tài nguyên DR. Vui lòng nhập mã định danh DR.",
      key604: "Đăng ký thiết bị điện.",
      key605: "Cần thêm loại thiết bị",
      key606: "Vui lòng nhập tên thiết bị điện.",

      // 전력기기 상세정보
      key607: "Không thể cài đặt nhiệt độ mục tiêu của nồi hơi.",
      key608: "Bạn có muốn tắt không?",
      key609: "Bạn có muốn bật không?",
      key610: "Có",
      key611: "Không",
      key612: "Thực hiện thành công.",
      key613: "Thao tác đã bị hủy.",
      key614: "Quản lý nguồn điện riêng lẻ thất bại.",
      key615: "Toàn bộ nguồn điện",
      key616: "Quản lý toàn bộ nguồn điện thất bại.",
      key617: "Thiết bị này không có dữ liệu nhiệt độ.",
      key618: "Thiết bị này không thể điều chỉnh nhiệt độ.",
      key619: "Nhiệt độ mục tiêu của thiết bị này là",
      key620: "Tối thiểu",
      key621: "Tối đa",
      key622: "°C",
      key623: "Bạn có muốn hủy chế độ kiểm tra thiết bị không?",
      key624: "Đặt tất cả thiết bị ở chế độ kiểm tra?",
      key625: "(Phụ/Chi tiết)",
      key626: "Biểu đồ tiêu thụ điện theo giờ (Đơn vị: kWh)",
      key627: "Tiêu thụ điện",
      key628: "Biểu đồ tiêu thụ điện theo ngày (Đơn vị: kWh)",
      key629: "Biểu đồ tiêu thụ điện lũy kế (Đơn vị: kWh)",
      key630: "Hàng tháng",
      key631: "Hàng quý",
      key632: "Hàng năm",

      // 배터리 추가 수정
      key633: "Vui lòng nhập tên pin.",
      key634: "Vui lòng nhập tên model.",
      key635: "Vui lòng nhập dung lượng pin.",
      key636: "Vui lòng nhập số site.",
      key637: "Vui lòng nhập số RTU.",
      key638: "Vui lòng nhập số thiết bị.",
      key639: "Vui lòng nhập ngày bắt đầu vận hành.",
      key640: "Vui lòng nhập thời hạn bảo hành dịch vụ.",
      key641: "Đã hủy.",

      // 배터리 상세
      key642: "Không thể tải thông tin pin",
      key643: "S-1 Muối NaCl",
      key644: "B-1 Bazơ NaOH",
      key645: "A-1 Axit HCl",
      key646: "E-1 Điện giải Na2SO4",
      key647: "S-2 Muối NaCl",
      key648: "B-2 Bazơ NaOH",
      key649: "A-2 Axit HCl",
      key650: "Xả",
      key651: "S-1 Muối NaCl",
      key652: "B-1 Bazơ NaOH",
      key653: "A-1 Axit HCl",
      key654: "E-1 Điện giải Na2SO4",
      key655: "S-2 Muối NaCl",
      key656: "B-2 Bazơ NaOH",
      key657: "A-2 Axit HCl",
      key658: "pH bể chứa (0.0 ~ 14.0 pH)",
      key659: "Độ dẫn điện bể chứa (0.0 ~ 500.0 ms)",
      key660: "Chế độ sạc/xả",
      ...auth.vi,
      ...ems.vi,
      ...inverterDetail.vi
    }
  }
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: util.getLocale(),
  })

export default i18n

